export default {
    baseURL: 'https://traking-api.iryka.com/',
    qrCode: {
        create: 'qr-codes/create',
    },
    rapports: {
        getCampagnePositions: 'rapports/campagne',
        getDatePositions: 'rapports/date',
    },
    commercial: {
        postAddNewCommercial: 'auth/commercial/register',
        getAllCommercials: 'auth/commercial',
    },
}